import React, { useState, useEffect } from 'react';
import {
    Grid,
    TextField,
    Typography,
    Card,
    Link,
} from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import SimpleFooter from "examples/Footers/SimpleFooter";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "trainerRoutes";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import Container from "@mui/material/Container";
import MKTypography from "components/MKTypography";
import Autocomplete from '@mui/material/Autocomplete';
import SearchIcon from "@mui/icons-material/Search";
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import editRoutes from "trainerEditRoutes";
import Advertisement from '../Advertisement/Advertisement';
import defaultRoutes from "routes";

const Page = () => {
    const [search, setSearch] = useState("");
    const [modeOfTraining, setModeOfTraining] = useState("");
    const [classroomLocation, setClassroomLocation] = useState("");
    const [budget, setBudget] = useState("");
    const [budgetRangeFrom, setBudgetRangeFrom] = useState("");
    const [budgetRangeTo, setBudgetRangeTo] = useState("");
    const [commercialsLessThan4hrs, setCommercialsLessThan4hrs] = useState("");
    const [commercials4hrs, setCommercials4hrs] = useState("");
    const [commercials8hrs, setCommercials8hrs] = useState("");
    const [labCostPerParticipants, setLabCostPerParticipants] = useState("");
    const [serverCount, setServerCount] = useState("");
    const [typeOfServer, setTypeOfServer] = useState("");
    const [courseDuration, setCourseDuration] = useState("");
    const [lastClient, setLastClient] = useState("");
    const [trainingComment, settrainingComment] = useState("");
    const [userId, setUserId] = useState("");
    const [showLocationField, setShowLocationField] = useState(false);
    const [skillsName, setSkillsName] = useState([]);
    const [trainingList, setTrainingList] = useState([]);
    const [bbdata, setbbData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [submitCompleted, setSubmitCompleted] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [trainerProfileCreate, setTrainerProfileCreate] = useState(false);
    const [emailVerified, setEmailVerified] = useState(false);
    const [mobVerified, setMobVerified] = useState(false);
    const [tcVerified, setTcVerified] = useState(false);

    const displayAdvertisement = process.env.REACT_APP_ADVERTISEMENT === 'yes';
    console.log("process.env.REACT_APP_ADVERTISEMENT", process.env.REACT_APP_ADVERTISEMENT);
    console.log("displayAdvertisement", displayAdvertisement);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.detail) {
                } else {
                    setSkillsName(["ANY", ...data]);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);
    console.log("skillsName", skillsName);

    const navigate = useNavigate();

    const onSubmitClick = async () => {
        if (!search && !modeOfTraining) {
            setErrorMessage("Please apply filters to search Trainings");
        } else {
            const queryString = `?search=${search}&modeOfTraining=${modeOfTraining}&classroomLocation=${classroomLocation}`;
            navigate(`/app/traininglist${queryString}`);
        }
    };

    useEffect(() => {
        let technology = search === "ANY" ? "" : search;
        const apiUrl = localStorage.getItem("userId")
            ? `${process.env.REACT_APP_API_URL}/api/getSearchtech-training/${localStorage.getItem("userId")}/${technology}`
            : `${process.env.REACT_APP_API_URL}/api/getSearchtech-training/${technology}`;

        fetch(`${apiUrl}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (!data.detail) {
                    setbbData(data);
                    setTrainingList(data.results || data);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, [search]);


    console.log("trainingList", trainingList);
    console.log("data", bbdata);

    const onClearFilterClick = () => {
        setSearch("");
        setBudget("");
        setBudgetRangeFrom("");
        setBudgetRangeTo("");
        setModeOfTraining("");
        setClassroomLocation("");
        setShowLocationField(false);
        setErrorMessage("");
    };

    const totalPages = bbdata.count > 0 ? Math.ceil(bbdata.count / bbdata.results.length) : 0;

    console.log("currentPage", currentPage);

    const handleSearchChange = (event, value) => {
        const typedSkill = event.target.value;
        console.log("typedSkill@@@@@@@@@@@@@", typedSkill);
        if (typedSkill && !skillsName.includes(typedSkill)) {
            fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/?q=${typedSkill}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
                .then((resp) => resp.json())
                .then((data) => {
                    setSkillsName([...skillsName, ...data]);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
        setSearch(value.join(','));
    };
    console.log("search", search);
    console.log("commercialsLessThan4hrs", commercialsLessThan4hrs);
    console.log("commercials4hrs", commercials4hrs);
    console.log("commercials8hrs", commercials8hrs);
    console.log("serverCount", serverCount);
    console.log("typeOfServer", typeOfServer);
    console.log("labCostPerParticipants", labCostPerParticipants);
    console.log("courseDuration", courseDuration);
    console.log("lastClient", lastClient);
    console.log("trainingComment", trainingComment);

    useEffect(() => {
        const id = localStorage.getItem("userId");
        console.log(id);
        setUserId(id);

        if (id) {
            fetch(`${process.env.REACT_APP_API_URL}/api/userdetails/${id}/`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.detail) {
                    } else {
                        setEmailVerified(data.is_verified);
                        setMobVerified(data.is_verified_mobile);
                        setTcVerified(data.is_verified_tc);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, [localStorage.getItem("token")]);

    useEffect(() => {
        const id = localStorage.getItem("userId");
        if (id) {
            fetch(`${process.env.REACT_APP_API_URL}/api/trainerprofileuidexists/${id}/`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.exists === false) {
                        setTrainerProfileCreate(true);
                        window.location.href = "/app/trainerprofile";
                    } else {
                        setTrainerProfileCreate(false);
                    }
                })
                .catch(error => {
                    console.error("Error fetching data:", error);
                });
        }
    }, [localStorage.getItem("userId")]);

    console.log("trainerProfileCreate", trainerProfileCreate);

    return (
        <>
            <DefaultNavbar
                routes={localStorage.getItem("userId") ? (trainerProfileCreate ? routes : editRoutes) : defaultRoutes}
                sticky
            />
            <Card
                sx={{
                    height: '790px',
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <Container maxWidth="sm">
                    <form>
                        <Grid container style={{ marginTop: "130px" }} spacing={2}>
                            <Grid item xs={12} sm={3}>
                                <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h2" color="text">
                                    <span style={{ color: 'black' }}>Search</span>{' '}
                                    <span style={{ color: '#2e1114' }}>Trainings</span>
                                </MKTypography>
                            </Grid>
                        </Grid>
                        <Grid container style={{ marginTop: '20px' }}>
                            <div>
                                <Typography variant="h5" style={{ color: 'black' }}>Search by Skills</Typography>
                                <Autocomplete
                                    multiple
                                    id="skills"
                                    options={skillsName}
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Skill"
                                            variant="standard"
                                            style={{ marginTop: '10px', width: '700px' }}
                                            fullWidth
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <SearchIcon fontSize="medium" />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    )}
                                    onChange={(event, value) => handleSearchChange(event, value)}
                                />
                            </div>
                            <Grid item xs={12} md={8}>
                                <Grid item xs={12} md={10}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                        {/* <Link href="#" onClick={onClearFilterClick} style={{ textDecoration: 'underline', color: 'blue', cursor: 'pointer', fontSize: 'small' }}>
                                            Clear Filters
                                        </Link> */}
                                        <MKButton variant="gradient" color="info" size="small" style={{whiteSpace: 'nowrap' }} onClick={onClearFilterClick} >Clear Filters</MKButton>
                                        <MKButton variant="gradient" color="info" size="small" style={{ marginLeft: '10px' }} onClick={onSubmitClick} >Submit</MKButton>
                                    </div>
                                    <div>
                                        {errorMessage && <Typography color="error" style={{ marginTop: "10px", fontSize: "13px", lineHeight: "1.2" }}>{errorMessage}</Typography>}
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                        {displayAdvertisement && <Advertisement />}
                    </form>
                </Container>
            </Card>
            <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
                    <SimpleFooter />
                </MKBox>
            </div>
        </>
    );
}

export default Page;